import type { RaceView, RoomView, RunView } from "./types";

export type CombatMode = "idle" | "single" | "room" | "race";

export interface CombatViewState {
  mode: CombatMode;
  view: RunView | null;
  roomView: RoomView | null;
  raceView: RaceView | null;
}

export function normalizeRefillPreview(value: unknown): number[] {
  if (!Array.isArray(value)) return [];
  return value.filter((tile): tile is number => Number.isInteger(tile) && tile >= 0 && tile <= 5);
}

export function normalizeRunView(view: RunView): RunView {
  return { ...view, refillPreview: normalizeRefillPreview(view.refillPreview) };
}

export function singleCombatState(view: RunView | null = null): CombatViewState {
  return {
    mode: "single",
    view: view ? normalizeRunView(view) : null,
    roomView: null,
    raceView: null,
  };
}

export function roomCombatState(roomView: RoomView | null = null): CombatViewState {
  return { mode: "room", view: null, roomView, raceView: null };
}

export function raceCombatState(raceView: RaceView | null = null): CombatViewState {
  return { mode: "race", view: null, roomView: null, raceView };
}

export function clearedCombatState(): CombatViewState {
  return { mode: "idle", view: null, roomView: null, raceView: null };
}

export function restoredCombatState(
  view: RunView | null,
  roomView: RoomView | null,
  raceView: RaceView | null,
): CombatViewState {
  if (roomView && (roomView.room.status !== "ended" || roomView.room.mode === "raid")) {
    return roomCombatState(roomView);
  }
  if (raceView?.race.status === "active") {
    return raceCombatState(raceView);
  }
  if (view) return singleCombatState(view);
  return clearedCombatState();
}
